import React, { useState } from 'react';

export interface GlossaryEntry {
  term: string;
  definition: string;
}

interface GlossaryProps {
  entries: GlossaryEntry[];
}

export default function Glossary({ entries }: GlossaryProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        style={styles.btn}
        title="Glossary"
        aria-label="Toggle glossary"
      >
        ?
      </button>
      {open && (
        <div style={styles.overlay} onClick={() => setOpen(false)}>
          <div style={styles.panel} onClick={(e) => e.stopPropagation()}>
            <div style={styles.header}>
              <h3 style={styles.title}>Glossary</h3>
              <button onClick={() => setOpen(false)} style={styles.closeBtn}>&times;</button>
            </div>
            <div style={styles.body}>
              {entries.map((entry) => (
                <div key={entry.term} style={styles.entry}>
                  <dt style={styles.term}>{entry.term}</dt>
                  <dd style={styles.def}>{entry.definition}</dd>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const styles: Record<string, React.CSSProperties> = {
  btn: {
    position: 'fixed', top: 16, right: 24, zIndex: 100,
    width: 36, height: 36, borderRadius: '50%',
    backgroundColor: '#2b6cb0', color: '#fff',
    border: 'none', cursor: 'pointer',
    fontSize: 18, fontWeight: 700,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
  },
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 200,
    display: 'flex', justifyContent: 'flex-end',
  },
  panel: {
    width: 400, maxWidth: '90vw', height: '100vh',
    backgroundColor: '#1a202c', borderLeft: '1px solid #2d3748',
    display: 'flex', flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '16px 20px', borderBottom: '1px solid #2d3748',
  },
  title: { fontSize: 16, fontWeight: 700, color: '#e2e8f0', margin: 0 },
  closeBtn: {
    background: 'none', border: 'none', color: '#a0aec0',
    fontSize: 24, cursor: 'pointer', padding: 0, lineHeight: 1,
  },
  body: {
    flex: 1, overflowY: 'auto', padding: '12px 20px',
  },
  entry: {
    marginBottom: 12, paddingBottom: 12,
    borderBottom: '1px solid #2d3748',
  },
  term: {
    color: '#63b3ed', fontSize: 13, fontWeight: 700, marginBottom: 2,
  },
  def: {
    color: '#cbd5e0', fontSize: 12, lineHeight: 1.5, margin: 0,
  },
};
